module.exports = __webpack_public_path__ + "img/icon-interactive-kiosk-maps.f3b871fd.png";